module.exports = __webpack_public_path__ + "static/media/404.1e6e1c9f.gif";